var $$ajax = require('./ajax');

var $$config = require('config');

var isLogin = function () {
    if (!window.focus_uid) {
        if (window.env === 'pc') {
            window.FCLoginHeader && FCLoginHeader.open();
        } else {
            window.location.href = $$config.loginUrl + '?ru=' + window.encodeURIComponent(window.location.href);
        }
        return false;
    }
    return true;
};

module.exports = {
    concern: function (uid, fn) {
        if (!isLogin()) {
            return;
        }
        var _this = this;
        var data = {
            appId: '1100',
            followUid: uid || window.uid
        };
        $$ajax.post($$config.uDomain + '/api/v1/follow',
            data, fn);
    },
    unConcern: function (uid, fn) {
        if (!isLogin()) {
            return;
        }
        var _this = this;
        var data = {
            appId: '1100',
            unfollowUid: uid || window.uid
        };
        $$ajax.post($$config.uDomain + '/api/v1/unfollow',
            data, fn);
    },
    infoGet:function(uid,fn){
        // if(!isLogin()){
        //     return;
        // }
        var data = {
            uid: uid || window.uid
        };
        $$ajax.get($$config.accountInfo+'/user/profile/information',data,fn)
    },
    isLogin:isLogin
};



// WEBPACK FOOTER //
// ./src/model/profile.js